G.ActionMove = function(board,am,args) {

	G.Action.call(this,board,am,args);

	this.candy1 = args[0];
	this.candy1orgParent = this.candy1.parent;
	this.candy2 = args[1];
	this.candy2orgParent = this.candy2.parent;
	this.forceMove = args[2];
	this.back = false;

	this.startAnimation();
   
};

G.ActionMove.prototype = Object.create(G.Action.prototype);

G.ActionMove.prototype.update = function() {

  var self = this;

	this.updateAnimation();
	this.progress += 0.075*G.deltaTime; 

	if (this.progress >= 1) {

		this.finishAnimation();

		if (this.back) {return this.finish()};


		this.candy1.movedWith(this.candy2);
		this.candy2.movedWith(this.candy1);


		//COMBO
		if (this.candy1.hasSpecialType() && this.candy2.hasSpecialType()) {

			//check combo also process CANDY!!!!
			if (this.checkCombo(this.candy1,this.candy2)) {
				G.lvl.madeMove();
				this.am.newAction('processMatch');
				return this.finish();

			}else if (this.candy1.getSpecialTypeName() == 'spiral' || this.candy2.getSpecialTypeName() == 'spiral') {
				//check spiral matches
				var spiral = this.candy1.getSpecialTypeName() == 'spiral' ? this.candy1 : this.candy2;  
				var other = this.candy1.getSpecialTypeName() != 'spiral' ? this.candy1 : this.candy2;

        checkForCollectables(this.candy1, this.candy2);

				other.startAnimation('moveTo',[0,spiral.cellX,spiral.cellY]);
				spiral.specialType.exe = [["changeTypeInto",other.getBaseTypeSymbol() >= 1 ? other.getBaseTypeSymbol() : game.rnd.between(1,this.board.MAX_NUMBER_OF_REGULAR_CANDY),other.getSpecialTypeName()]];
				this.board.checkMatchList.push(spiral);

				G.lvl.madeMove();
				this.am.newAction('processMatch');
        this.candy1.markSuccessfulMove(this.candy2);
        this.candy2.markSuccessfulMove(this.candy1);
				return this.finish();

			}else {
				//if there is no combo, just activate both candies
				this.candy1.activatedByMove = true;
				this.candy2.activatedByMove = true;
				this.board.checkMatchList.push(this.candy1);
				this.board.checkMatchList.push(this.candy2);
				G.lvl.madeMove();
				this.am.newAction('processMatch');
        this.candy1.markSuccessfulMove(this.candy2);
        this.candy2.markSuccessfulMove(this.candy1);
				return this.finish();
			}
		}


		//NORMAL
    if (this.additionalChecks(this.candy1, this.candy2)) {
  		if (this.board.matcher.isMoveValid(this.candy1)) this.board.checkMatchList.push(this.candy1);
  		if (this.board.matcher.isMoveValid(this.candy2)) this.board.checkMatchList.push(this.candy2);
    }

		if (this.board.checkMatchList != false) {
			this.candy1.movedWith(this.candy2);
			this.candy2.movedWith(this.candy1);
			if (!this.forceMove) G.lvl.madeMove();
			this.am.newAction('processMatch');
      this.candy1.markSuccessfulMove(this.candy2);
      this.candy2.markSuccessfulMove(this.candy1);
			return this.finish();
		}

		//if allreadyback or rabbit
		if (this.back || this.forceMove) {
			this.finish();
		}else {
			this.back = true;
			this.startAnimation();
		}
		

	}//this.finish();

  function checkForCollectables(candyA, candyB) {
    if (self._areCandiesSpecialsCombo(candyA, candyB, "spiral", "cross")) {
      G.sb("onCollectableRemove").dispatch("bombCrossCombo");
    } else if (self._areCandiesSpecialsCombo(candyA, candyB, "spiral", "horizontal")
      || self._areCandiesSpecialsCombo(candyA, candyB, "spiral", "vertical")) {
      G.sb("onCollectableRemove").dispatch("bombVertHorCombo");
    }
  }

};

G.ActionMove.prototype.additionalChecks = function(candy1, candy2) {
  var spiralBomb = [candy1, candy2].find(function(c){return c.getSpecialTypeName() == "spiral"}); 
	var goalCandy = [candy1, candy2].find(function(c){return c.getBaseTypeSymbol() === "goalCandy"});
	const burntCandy = [candy1, candy2].find(function(c){return c.getBaseTypeSymbol() === "burntCandy"});
  var chest = [candy1, candy2].find(function(c){return c.getBaseTypeSymbol().indexOf("chest") > -1});
	var cake = [candy1, candy2].find(function(c){return c.getBaseTypeSymbol().indexOf("lc") === 0});
	var fortune = [candy1, candy2].find(function(c){return c.getBaseTypeSymbol().indexOf("fortune") === 0});
	var infection = [candy1, candy2].find(function(c){return c.getBaseTypeSymbol() === "infection"});
	if ((spiralBomb && goalCandy)
		|| (spiralBomb && burntCandy)
  	|| (spiralBomb && infection)
		|| (spiralBomb && fortune)
  	|| (spiralBomb && chest)
  	|| (spiralBomb && cake)) return false;

  return true;
};


G.ActionMove.prototype.startAnimation = function() {

	G.sfx.exchange.play();

	this.candy1anim = {
		startX: this.candy1.x,
		deltaX: this.candy2.x - this.candy1.x,
		startY: this.candy1.y,
		deltaY: this.candy2.y - this.candy1.y
	};

	this.board.boardCandies.secondFloor.add(this.candy1);

	this.candy2anim = {
		startX: this.candy2.x,
		deltaX: this.candy1.x - this.candy2.x,
		startY: this.candy2.y,
		deltaY: this.candy1.y - this.candy2.y
	};

	this.board.boardCandies.secondFloor.add(this.candy2);

	this.candy1.bringToTop();

	
	this.progress = 0;

	if (G.IMMEDIATE) this.progress = 1;

};

G.ActionMove.prototype.finishAnimation = function() {

	this.board.swapCandies(this.candy1,this.candy2);
	this.candy1.x = this.board.cellXToPxIn(this.candy1.cellX);
	this.candy1.y = this.board.cellYToPxIn(this.candy1.cellY);
	this.candy1.scale.setTo(1);
	this.candy1orgParent.add(this.candy1);
	this.candy2.x = this.board.cellXToPxIn(this.candy2.cellX);
	this.candy2.y = this.board.cellYToPxIn(this.candy2.cellY);
	this.candy2orgParent.add(this.candy2);

};

G.ActionMove.prototype.updateAnimation = function() {

	var animProgress = Phaser.Easing.Sinusoidal.InOut(this.progress);

	this.candy1.x = this.candy1anim.startX+(animProgress*this.candy1anim.deltaX);
	this.candy1.y = this.candy1anim.startY+(animProgress*this.candy1anim.deltaY);

	this.candy1.scale.setTo(2-(Math.abs(0.5-animProgress)*2));


	this.candy2.x = this.candy2anim.startX+(animProgress*this.candy2anim.deltaX);
	this.candy2.y = this.candy2anim.startY+(animProgress*this.candy2anim.deltaY);
	

};

G.ActionMove.prototype.checkCombo = function(candy1,candy2) {

  var combos = G.Helpers.candyDataMgr.getCombos();
	var combo;

	for (var i = 0, len = combos.length; i < len; i++) {
		combo = combos[i];

    if (this._areCandiesSpecialsCombo(candy1, candy2, combo[0], combo[1])) {
			var moveRot = combo[3];

			//special case - order of candies (rotation of candy that doesnt move might be needed)
			if ((combo[0] == "vertical" || combo[0] == "horizontal") && combo[1] == "cross") {
				if (candy1.getSpecialTypeName() == "vertical" || candy1.getSpecialTypeName() == "horizontal") {
					game.add.tween(candy1).to({angle: combo[3]},300,Phaser.Easing.Sinusoidal.InOut,true);
					moveRot = 0;
				}
			}

			candy1.changeInto(combo[2]);
			candy2.changeInto("emptySpecial");
			candy2.detachFromGrid();
			candy2.startAnimation('moveToCombo',[0,candy1.cellX,candy1.cellY,moveRot]);
			
			if (!candy1.onMatchFx) candy1.onMatchFx = [];
			candy1.onMatchFx.push(['dummyComboGrowAndFade',[candy2.frameName,moveRot]]);
			
			candy2.bringToTop();
			// candy2.getBaseTypeSymbol() = Math.random();
			candy1.activatedByMove = true;
			this.board.checkMatchList.push(this.candy1);
			return true;

		}
	};

	return false;
};

G.ActionMove.prototype._areCandiesSpecialsCombo = function(candyA, candyB, specialTypeA, specialTypeB) {
  return (candyA.getSpecialTypeName() == specialTypeA && candyB.getSpecialTypeName() === specialTypeB)
    || (candyA.getSpecialTypeName() == specialTypeB && candyB.getSpecialTypeName() === specialTypeA);
};